import { defineMessages } from 'react-intl';
import globalMessages from '../../../utils/globalMessages';

export default defineMessages({
    ...globalMessages,

    pendingOrdersCounter: {
        id: 'dashboard.pendingOrdersCounter',
        defaultMessage: 'collection(s) cadastrado(s)',
    },
});
